import { makeStyles, withStyles } from "@material-ui/core/styles";
import Divider from "@material-ui/core/Divider";

export const StyledDivider = withStyles((theme) => ({
  root: {
    width: 2,
    background: theme.palette.primary.main,
    margin: theme.spacing(0, 1),
  },
}))(Divider);

export const useStyles = makeStyles((theme) => ({
  submit: {
    margin: theme.spacing(2, 0, 2),
  },
  container: {
    height: "100%",
  },
  item: {
    width: 420,
  },
  wrapper: {
    padding: 50,
  },
  link: {
    color: "gray",
  },
  activeLink: {
    fontWeight: 600,
  },
}));
